export class UnitCustomFieldWithPermissions {
    id: number;
    name: string;
    canView: boolean = false;
    canEdit: boolean = false;
    valueId?: number;
    value: string;
    organizationId: number;

    constructor(field: any) {
        if (field.id) {
            this.id = field.id;
        }

        if (field.name) {
            this.name = field.name;
        }

        if (field.valueId) {
            this.valueId = field.valueId;
        }

        if (field.value) {
            this.value = field.value;
        }

        if (field.organizationId) {
            this.organizationId = field.organizationId;
        }

        if(field.canView) {
            this.canView = field.canView;
        }

        if(field.canEdit) {
            this.canEdit = field.canEdit;
        }
    }
}
